import { UseFormReturn } from "react-hook-form";
import { Unstable_Grid2 as Grid } from "@mui/material";
import { FormatedField } from "../../types/fields.types";
import { CalendarFiltersType } from "./calendar.types";
import { useRecords } from "../../api/useRecords";
import { STALE_TIME_24H } from "../../utils/constants";
import { CalenderFilterSelectField } from "./CalenderFilterSelectField";
import { CalendarTechnicianFilter } from "./CalendarTechnicianFilter";
import { useIsMobile } from "../../utils/useIsMobile";

export type CalendarFiltersProps = {
	entityForm: UseFormReturn;
	calendarFilters: CalendarFiltersType | null;
	fields: {
		statusField: FormatedField | undefined;
	};
};

export const CalendarFilters = ({ entityForm, fields }: CalendarFiltersProps) => {
	const { statusField } = fields;
	const isMobile = useIsMobile();

	return (
		<Grid
			container
			maxWidth="100%"
			flexDirection="row"
			rowSpacing={5}
			columnSpacing={isMobile ? 0 : 5}
			flexGrow={1}
		>
			<Grid xs={12} lg={3}>
				<ClinicFilter entityForm={entityForm} />
			</Grid>
			<Grid xs={12} lg={3}>
				<ServiceCategoryFilter entityForm={entityForm} />
			</Grid>
			<Grid xs={12} lg={3}>
				<CalendarTechnicianFilter entityForm={entityForm} />
			</Grid>
			<Grid xs={12} lg={3}>
				{statusField && <SessionStatusFilter entityForm={entityForm} field={statusField} />}
			</Grid>
		</Grid>
	);
};

type ClinicFilterProps = {
	entityForm: UseFormReturn;
};

const ClinicFilter = ({ entityForm }: ClinicFilterProps) => {
	const { status, data } = useRecords("clinics", "*.*", {
		fetch: { fetchOnFocus: false },
		staleTime: STALE_TIME_24H
	});

	if (status !== "success") return null;

	return (
		<CalenderFilterSelectField
			entityForm={entityForm}
			fieldName="clinic_id"
			label="Clínica"
			options={data.items}
			propertyToMatch="id"
		/>
	);
};

type SessionStatusProps = {
	entityForm: UseFormReturn;
	field: FormatedField;
};

const SessionStatusFilter = ({ entityForm, field }: SessionStatusProps) => {

	return (
		<CalenderFilterSelectField
			entityForm={entityForm}
			fieldName="status"
			label="Estado"
			options={field.settings?.options?.choices}
			propertyToMatch="value"
		/>
	);
};

type ServiceCategoryProps = {
	entityForm: UseFormReturn;
};

const ServiceCategoryFilter = ({ entityForm }: ServiceCategoryProps) => {
	const options = [
		{
			value: "evaluations_first",
			text: "Avaliações (Primeiras)"
		},
		{
			value: "evaluations_others",
			text: "Re-avaliações"
		},
		{
			value: "neurofeedback",
			text: "NeuroFeedback"
		},

		{
			value: "reports_first",
			text: "Consultas de Avaliação"
		},
		{
			value: "reports_others",
			text: "Consultas de Re-avaliação"
		},
		{
			value: "followup",
			text: "Reuniões de Acompanhamento"
		},
		{
			value: "psicologia",
			text: "Psicologia"
		},
		{
			value: "parental_counselling",
			text: "Aconselhamento Parental"
		}
	];

	return (
		<CalenderFilterSelectField
			entityForm={entityForm}
			fieldName="service_category"
			label="Serviço"
			options={options}
			propertyToMatch="value"
		/>
	);
};
